// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"__404_errorPage__Kh7uj","circle":"__404_circle__uj_rB","icon":"__404_icon__tu9Ev"};